import React from "react";
import "./App.css";
import { ThemeProvider } from "@mui/material";
import Router from "./routes";
import { lightTheme } from "./theme";
import {
  QueryClient,
  QueryClientProvider,
  QueryErrorResetBoundary,
} from "@tanstack/react-query";
import { NotificationServiceProvider } from "./hooks/notification";
import { Provider } from "react-redux";
import store from "./store/store"; // Import your store here
import { DrawerProvider } from "./hooks/useDrawer";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./components/error-handler";

const queryClient = new QueryClient();

function App() {
  const logErrorToService = (error: Error) => {
    // Send to error logging service
    console.error("Logged error:", error);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <QueryErrorResetBoundary>
        {({ reset }) => (
          <ErrorBoundary onReset={reset} FallbackComponent={ErrorFallback}>
            <Provider store={store}>
              <NotificationServiceProvider>
                <DrawerProvider>
                  <ThemeProvider theme={lightTheme}>
                    <Router />
                  </ThemeProvider>
                </DrawerProvider>
              </NotificationServiceProvider>
            </Provider>
          </ErrorBoundary>
        )}
      </QueryErrorResetBoundary>
    </QueryClientProvider>
  );
}

export default App;
